export class Events {
    constructor(onerror = (_err) => { }) {
        this.onerror = onerror;
        this.events = {};
    }
    subscribe(handlers) {
        for (const key in handlers) {
            this.on(key, handlers[key]);
        }
        return {
            dispose: () => {
                for (const key in handlers) {
                    this.off(key, handlers[key]);
                }
            },
            handlers,
        };
    }
    on(event, handler) {
        if (event in this.events) {
            this.events[event].push(handler);
        }
        else {
            this.events[event] = [handler];
        }
    }
    off(event, handler) {
        if (handler && this.events[event]) {
            this.events[event] = this.events[event].filter((cb) => cb !== handler);
        }
        else {
            this.events[event] = [];
        }
    }
    emit(event, arg) {
        for (const handler of this.events[event] || []) {
            try {
                if (handler.length) {
                    handler(arg);
                }
                else {
                    // @ts-ignore
                    handler();
                }
            }
            catch (error) {
                this.onerror(error);
            }
        }
    }
    clear() {
        this.events = {};
    }
}
